/**
 * @generated SignedSource<<48acc1dc6e52a2f78f010a407584563e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type QuoteRuleInput = {
  allowAddToCart?: boolean | null;
  formControlsData?: string | null;
  isValidForAllProducts?: boolean | null;
  name?: string | null;
  notifyEmailList?: string | null;
  products?: ReadonlyArray<number> | null;
  quoteRuleID: number;
};
export type productSidePanelContent_UpdateQuoteRuleMutation$variables = {
  input: QuoteRuleInput;
};
export type productSidePanelContent_UpdateQuoteRuleMutation$data = {
  readonly quoteRuleUpdate: {
    readonly id: string;
    readonly isValidForAllProducts: boolean;
    readonly products: ReadonlyArray<number> | null;
  };
};
export type productSidePanelContent_UpdateQuoteRuleMutation = {
  response: productSidePanelContent_UpdateQuoteRuleMutation$data;
  variables: productSidePanelContent_UpdateQuoteRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "QuoteRule",
    "kind": "LinkedField",
    "name": "quoteRuleUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isValidForAllProducts",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "products",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_UpdateQuoteRuleMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_UpdateQuoteRuleMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b7bbdaca7cc4192186e0354c33fdfa02",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_UpdateQuoteRuleMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_UpdateQuoteRuleMutation(\n  $input: QuoteRuleInput!\n) {\n  quoteRuleUpdate(input: $input) {\n    id\n    isValidForAllProducts\n    products\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff21f238194b7ff21dfcf9d02a7b9ffb";

export default node;
